import React from 'react';
import ErrorBoundary from './error-boundary';

class PluginRegion extends React.Component {
  render(){
    const { className, styleOverride, components } = this.props;
    return (
      <div className={className}>
        {
          components.map((component, i) => {
            const Comp = component;
            return (
              <ErrorBoundary key={i}>
                <div style={styleOverride}>
                  <Comp />
                </div>
              </ErrorBoundary>
            )
          })
        }
      </div>
    )
  }
}

export default PluginRegion;